import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';
import { RippleModule } from 'primeng/ripple';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { Router, RouterLink } from '@angular/router';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { NotificationsResponse } from '../../../models/notification/notificationResponse';
import { NotificationComponent } from '../../../notification/notification.component';
import { Store } from '@ngxs/store';
import { UserSelectors } from '../../../states/user/user-selector';
import { UserStateModel } from '../../../states/user/user-state-model';
import { TourService } from '../../../services/utility/tour.service';
import { NotificationFactoryService } from '../../../services/notification/notification-factory.service';
import { ChatStateService } from '../../../services/chat/chat-state.service';
import { Observable } from 'rxjs';
import { MenuStateModel } from '../../../states/menu/menu-state-model';
import { ClarityCallPopupComponent } from '../../../shared/components/clarity-call-popup/clarity-call-popup.component';

@Component({
  selector: 'app-top-nav-bar',
  standalone: true,
  imports: [MenubarModule, BadgeModule, AvatarModule, TieredMenuModule, InputTextModule, RippleModule, CommonModule, MenuModule, ButtonModule, OverlayPanelModule, NotificationComponent, RouterLink, ClarityCallPopupComponent],
  templateUrl: './top-nav-bar.component.html',
  styleUrls: ['./top-nav-bar.component.scss']
})

export class TopNavBarComponent {
  showScheduleCallPopup: boolean = false;

  @ViewChild(NotificationComponent, { static: false }) notificationComponent!: NotificationComponent;

  user!: UserStateModel;
  items: MenuItem[] | undefined;
  items1: MenuItem[] | undefined;

  notifications: NotificationsResponse[] = [];
  lazyLoading: boolean = false;

  first: number = 0;
  unreadNotificationCount: number = 0;
  chatUnreadCount$!: Observable<number>;

  constructor(public router: Router,
    private store: Store, private tourService: TourService,
    private notificationFactoryService: NotificationFactoryService,
    private chatState: ChatStateService) {
    this.chatUnreadCount$ = this.chatState.totalUnreadCount$;
  }



  getUser() {
    this.store.select(UserSelectors.getUser).subscribe({
      next: (response) => {
        this.user = response;
      },
      error: (error) => {
        console.warn('Error fetching user:', error);
      }
    });
  }
  ngOnInit() {
    let userId = null;
    const storedData = JSON.parse(localStorage.getItem('account') ?? '');
    userId = storedData ? storedData.userId : null;
    this.getUser();
    this.chatState.connect();
    this.fetchUnreadNotificationCount();

    this.store.select((s: { menu: MenuStateModel }) => s.menu).subscribe((m) => {
      if (!m?.loaded) return;
      this.items = this.buildStaticStudentMenuItems();
    });

    this.items1 = [
      {
        label: 'Options',
        items: [
          {
            label: 'My Colleges',
            icon: 'pi pi-graduation-cap',
            command: () => {
              this.router.navigate(['portal', 'my-institutes']);
            }
          },
          {
            label: 'Account Centre',
            icon: 'pi pi-cog',
            command: () => {
              this.router.navigate(['portal', 'account-centre']);
            }
          },
          {
            label: 'View Profile',
            icon: 'pi pi-user',
            command: () => {
              this.router.navigate(['portal', 'view-profile', userId]);
            }
          },
          {
            label: 'Logout',
            icon: 'pi pi-sign-out',
            command: () => this.logout()
          }
        ]
      }
    ];
  }

  /** Fixed student menu — matches the design reference exactly. */
  private buildStaticStudentMenuItems(): MenuItem[] {
    return [
      { label: 'Discover Colleges', routerLink: 'institute-search' },
      { label: 'Document Vault', routerLink: 'student-document-vault' },
      { label: 'Direct Apply', routerLink: 'da-forms' },
      {
        label: 'Mentor',
        items: [
          { label: 'Mentors', routerLink: 'mentor-me' },
          { label: 'Peers', routerLink: 'peer' },
        ],
      },
      { label: 'Scholarship', routerLink: 'scholarships' },
      {
        label: 'Resources',
        items: [
          { label: 'Psychometric Test', routerLink: 'psychometric-test' },
          { label: 'Profile Builder', routerLink: 'profile-building-opportunities' },
           { label: 'Admission Calendar', routerLink: 'admission-calendar-student' },
          {
            label: 'Summer School',
            items: [
              { label: 'Summer Programs India', routerLink: 'summer-programs' },
              { label: 'Summer Programs Abroad', routerLink: 'summer-school-abroad' },
            ],
          },
          { label: 'Visa and Work Eligibility', routerLink: 'visa-and-work-eligibility' },
          { label: 'ROI Calculator', routerLink: '/portal/roi-calculator' },
          { label: 'Blogs', routerLink: 'blogs' },
          { label: 'Vlogs', routerLink: 'vlogs' },
        ],
      },
    ];
  }

  fetchUnreadNotificationCount() {
    this.notificationFactoryService.getUnreadNotificationCount().subscribe({
      next: (response) => {
        if (response) {
          this.unreadNotificationCount = response;
        } else {
          this.unreadNotificationCount = 0;
        }
      },
      error: () => {
        this.unreadNotificationCount = 0;
      }
    });
  }

  markAllAsRead() {
    this.notificationFactoryService.markAllAsRead().subscribe({
      next: (response) => {
        this.unreadNotificationCount = 0;
      }
    });
  }

  logout() {
    this.chatState.disconnect();
    localStorage.clear();
    this.router.navigate(['/signin']);
  }

  onStartTourClick(): void {
    this.tourService.triggerTour();
  }

  onChatIconClick(): void {
    if (this.router.url.includes('/portal/chat')) {
      // this.router.navigate(['/portal/dashboard']);
    } else {
      this.router.navigate(['/portal/chat']);
    }
  }

  get isChatPage(): boolean {
    return this.router.url.includes('/portal/chat');
  }
}
